import { Typography } from '@prenuvo/halo';

import { api } from '@/api';
import { formatTimeStampToUTC } from '@/shared/util';

type ActivityLogHeaderProps = {
  actor: string;
  timestamp: string;
};

export function ActivityLogHeader({ actor, timestamp }: ActivityLogHeaderProps) {
  const { data } = api.pii.patient.query.useGetPatient({
    payload: {
      params: {
        user_id: actor,
      },
    },
  });

  return (
    <div className="flex border-b pb-1">
      <Typography
        className="content-center"
        translationKey="FCT.ACTIVITY_LOGS.HEADER.TIMESTAMP"
        values={{ timestamp: formatTimeStampToUTC(timestamp) }}
        variant="paragraph-sm-bold"
      />

      <Typography
        as="label"
        className="ml-auto italic"
        translationKey="FCT.ACTIVITY_LOGS.HEADER.NAME"
        values={{ name: data?.[0]?.fullname }}
      />
    </div>
  );
}
